import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { ChargeTypeDto } from 'dtos/invoicing'

const baseUrl = (): string => '/api/charge-types'

export const getChargeTypes = () => apiClient.get<ApiResponse<ChargeTypeDto[]>>(baseUrl()).then(res => res.data)
